import { CartIcon, createWebviewScreen } from 'shared/src/component';

/**
 * 프로필 하위 개인정보 수정 화면들(`/mypage/profile/*`, 내용은 웹뷰).
 *
 * 전용 화면으로 두는 이유는 `MyProfile` 과 같다 — 범용 `WebViewScreen` 으로 열면 목적지가
 * `url` params 문자열로 들어가 주소가 유지되지 않는다.
 *
 * **동적 세그먼트(`/mypage/profile/:key`) 대신 경로마다 화면을 둔 이유**
 * 1. 헤더/문서 타이틀이 화면마다 다르다(서버 `<title>` 을 그대로 쓴다)
 * 2. 서버에 실제로 존재하는 4개만 앱 안에서 열려야 한다 — `/mypage/profile/<없는키>` 는
 *    404 이므로, 와일드카드로 받으면 오타 경로까지 앱 안에서 404 를 띄운다
 *
 * ⚠️ 모두 **로그인 필수** 지면이다. 비로그인 진입 시 콘텐츠가 `assertLogin` 메시지를 올리면
 * `useWebViewActionFromMessage` 가 앱 레벨 로그인으로 넘기고, 복귀 경로(`redirect`)로 현재
 * 주소를 넘긴다 — 전용 화면이라 그 주소가 실제 경로로 유지되는 게 여기서 이득이다.
 *
 * 타이틀은 스테이징 응답의 `<title>` 을 그대로 사용했다.
 */
export const MyProfileMobileScreen = createWebviewScreen({
  screen: 'MyProfileMobile',
  title: '휴대폰 번호',
  showHeader: true,
  rightIcons: [<CartIcon />],
});

export const MyProfilePasswordScreen = createWebviewScreen({
  screen: 'MyProfilePassword',
  title: '비밀번호',
});

export const MyProfileCustomNumberScreen = createWebviewScreen({
  screen: 'MyProfileCustomNumber',
  title: '개인통관고유부호',
  showHeader: false,
});

export const MyProfileRefundBankAccountScreen = createWebviewScreen({
  screen: 'MyProfileRefundBankAccount',
  title: '환불계좌',
  showHeader: true,
  rightIcons: [<CartIcon />],
});
